


// import { useContext, useEffect, useMemo, useState } from "react";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import {
  ListItemText,
  Skeleton,
  styled,
  Switch,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Snackbar,
  Box,
  Chip,
  Tooltip,
} from "@mui/material";
import {
  fetchCustomerLlms,
  getGeographies,
  getLlms,
  getMarkets,
  getCustomerMonitoringFiletrs,
  getCustomerMonitoringDates,
} from "../../services/apiService";
import classes from "./LLMReporting.module.css";
import { AuthContext } from "../../context/auth-context";
import { toast, ToastContainer } from "react-toastify";
import DashboardNav from "../Dashboard/common/DashboardNav";
import { useDispatch, useSelector } from "react-redux";
import React from "react";
import { fetchBrandProducts } from "../../redux/actions/brandProductsActions";
import { fetchBrands } from "../../redux/actions/brandsActions";
import api, { downloadFile } from "../../BrandOnBoarding/api";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { initialBrandTabs } from "./brand_data";
import { initialProdTabs } from "./prod_data";
import { Spinner } from "react-bootstrap";
import { handleInputValidation } from "../../utils/monitoring-helpers";
import { MONITORING_LLM_LABELS } from "../../utils/constant";
import ReportTemplateManager from './ReportTemplateManager';
import TemplateSelector from './TemplateSelector';
import ReportTemplateService from "../../services/reportTemplateService";
import { Save as SaveIcon, Close as CloseIcon } from '@mui/icons-material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { Menu, MenuItem } from '@mui/material';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles("dark", {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "#1a90ff",
    ...theme.applyStyles("dark", {
      backgroundColor: "#308fe8",
    }),
  },
}));

export default function LLMReporting() {
  const dispatch = useDispatch();
  const [selectedOptionShow, setSelectedOptionShow] = useState("Company/Brand"); //"Product"
  const [brandItems, setBrandItems] = useState([]);
  const [selectedBrandItems, setSelectedBrandItems] = useState([]);
  const [selectedProductItems, setSelectedProductItems] = useState([]);
  const [personas, setPersonas] = useState([]);
  const [selectedPersona, setSelectedPersona] = useState([]);
  const [productItems, setProductItems] = useState([]);
  const [inputValidation, setInputValidation] = useState({
    selectedProductItems: false,
    selectedBrandItems: false,
    selectedPersona: false,
    selectedGeographyItems: false,
    selectedMarketItems: false,
    selectedLlmItems: false,
  });
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [showData, setShowData] = useState(false);
  const [isDone, setIsDone] = useState(true);
  const [selectedLlmItems, setSelectedLlmItems] = useState([]);
  const [selectedLlmProviders, setSelectedLlmProviders] = useState([]);
  const [customerLlm, setCustomerLlm] = useState([]);
  const [selectedMarketItems, setSelectedMarketItems] = useState([]);
  const [selectedGeographyItems, setSelectedGeographyItems] = useState([]);
  const [dbLlms, setDbLlms] = useState([]);
  const [geography, setGeography] = useState([]);
  const [markets, setMarkets] = useState([]);
  const [activeSequence, setActiveSequence] = useState(initialBrandTabs);
  const [isLoading, setLoading] = useState(false);
  const { user } = useContext(AuthContext);
  const uid = user?.user_role?.user_id;
  const customerId = user?.customer_id || 0;
  const brandProducts = useSelector((state) => state.brandProducts);
  const brands = useSelector((state) => state.brands);
  const isCompanyUser = user?.user_role?.role?.name === "Company user"
  const [selectedSubFrequencyItems, setSelectedSubFrequencyItems] =
    useState("Current");
  const [percentCompleted, setPercentCompleted] = useState(0);
   // Nav tabs (optional: you can keep it fixed as "overview")
     const [activeTab, setActiveTab] = useState("overview");
   const handleTabClick = (tab) => setActiveTab(tab);


   // Category lists & selection
     const [categories, setCategories] = useState([]);
   const [selectedCategory, setSelectedCategory] = useState([]);
   const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);

   // Dates (for DateRangePicker in DashboardNav)
     const [startDate, setStartDate] = useState(null);
   const [endDate, setEndDate] = useState(null);
   const [availableDates, setAvailableDates] = useState([]);
   const [customDatesToDisplay, setCustomDatesToDisplay] = useState(null);

   // Filter modal (wire up later as needed)
     const [showFilterModal, setShowFilterModal] = useState(false);
   const [filterModalType, setFilterModalType] = useState("NA");
   const [isFilterActive, setIsFilterActive] = useState(false);
   const [monitoringFiletrs, setMonitoringFilters] = useState();
   const [customDateFilter, setCustomDateFilter] = useState('Recent')
   const [isChecked, setIsChecked] = useState(false);
  const downloadedForJobRef = useRef(null);
  const [templateManagerOpen, setTemplateManagerOpen] = useState(false);
  const [editingTemplate, setEditingTemplate] = useState(null);


       const [isFilterQuery, setIsFilterQuery] = useState(false);
       const [selectedFrequencyItems, setSelectedFrequencyItems] = useState([
           "Daily",
         ]);

                 const [value, setValue] = useState(0);

                   
  // Clear dialog state
  const [clearDialogOpen, setClearDialogOpen] = useState(false);
  const [selectedSections, setSelectedSections] = useState([]);
  const [lastState, setLastState] = useState(null); // for Undo
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [jobId, setJobId] = useState(null);
  const [jobStatus, setJobStatus] = useState(null); // queued|running|success|failed
  const [jobMessages, setJobMessages] = useState([]); // rolling backend messages
  const pollTimerRef = useRef(null);
  const initialPollTimerRef = useRef(null);
  const pollErrorCountRef = useRef(0);
  const [hasStarted, setHasStarted] = useState(false);
  const inFlightRef = useRef(false);
  const isBusy = isLoading || jobStatus === "running" || jobStatus === "pending" || inFlightRef.current || jobStatus === "cancelled";

  const [selectedTemplateInfo, setSelectedTemplateInfo] = useState(null);
  const [preEditSequence, setPreEditSequence] = useState(null);
  // Add this state to track the original template configuration
  const [originalTemplateSequence, setOriginalTemplateSequence] = useState(null);
  const [templateManagerMode, setTemplateManagerMode] = useState('list');
  const [saveMenuAnchor, setSaveMenuAnchor] = useState(null);
  const [originalIsChecked, setOriginalIsChecked] = useState(false);

  // Open / close dialog
  const openClearDialog = () => setClearDialogOpen(true);
  const closeClearDialog = () => {
    setSelectedSections([]);
    setClearDialogOpen(false);
  };

  // const computePercent = (job) => {
  //   if (!job || !job.totalSlides) return 1;
  //   let pct = Math.floor((Number(job.generatedSlides || 0) / Number(job.totalSlides || 1)) * 100);
  //   // keep UX snappy: cap at 99 until success
  //   if (job.status !== "success") pct = Math.min(pct, 99);
  //   return Math.max(1, Math.min(100, pct));
  // };


  // Toggle a section checkbox
  const toggleSection = (id) => {
    setSelectedSections((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  // Select all / none
  const selectAll = () => setSelectedSections(activeSequence.map((s) => s.id));
  const selectNone = () => setSelectedSections([]);

  // Apply clears
  const applyClear = () => {
    setLastState(activeSequence); // snapshot for Undo
    setActiveSequence((prev) =>
      prev.map((sec) =>
        selectedSections.includes(sec.id)
          ? { ...sec, config: sec.config.map((c) => ({ ...c, is_active: false })) }
          : sec
      )
    );
    closeClearDialog();
    setSnackbarOpen(true);
  };

  // Undo
  const handleUndo = () => {
    if (lastState) {
      setActiveSequence(lastState);
    }
    setSnackbarOpen(false);
  };
   



 useEffect(() => {
   const isNonEmpty = (v) => Array.isArray(v) && v.length > 0 && v.some((a) => a !== undefined);

   const inputVal = {
     // require exactly one of brand or product depending on the active tab
     selectedBrandItems: selectedOptionShow === "Company/Brand"
       ? isNonEmpty(selectedBrandItems)
       : true,
     selectedProductItems: selectedOptionShow === "Product"
       ? isNonEmpty(selectedProductItems)
       : true,

     // these must be chosen regardless of tab
     selectedCategory: isNonEmpty(selectedCategory),
     selectedGeographyItems: isNonEmpty(selectedGeographyItems),
     selectedMarketItems: isNonEmpty(selectedMarketItems),
     selectedPersona: isNonEmpty(selectedPersona),
     selectedLlmItems: isNonEmpty(selectedLlmItems),
   };

   setInputValidation(inputVal);
 }, [
   selectedProductItems,
     selectedBrandItems,
     selectedPersona,
     selectedGeographyItems,
     selectedMarketItems,
     selectedLlmItems,
     selectedCategory,
     selectedOptionShow,
 ])

  const isReady = () => Object.values(inputValidation).every(Boolean) && !isBusy;
  console.log("isReady== ", isReady());


  // useEffect(() => {
  //   async function fetchData() {
  //     const selectedBrandCustomerId = customerId;
  //     const customerSpecificLlms = await fetchCustomerLlms([
  //       Number(selectedBrandCustomerId),
  //     ]);

  //     setCustomerLlm(customerSpecificLlms?.data);
  //     const inputFilters = await getCustomerMonitoringFiletrs(customerId);

  //     let filters = {
  //       ...inputFilters,
  //       brands: [...(inputFilters?.brands || [])],
  //       products: [...(inputFilters?.products || [])],
  //     };

  //     setMonitoringFilters(filters);

  //     const newBrandItems = filters?.brands?.map((item) => {
  //       return { id: item?.customer_brand_id, name: item?.brand_name };
  //     });

  //     setBrandItems((prevItems) => [...newBrandItems]);
  //     // auto-pick first brand so the cascade can run
  //     if (!selectedBrandItems.length && newBrandItems?.length) {
  //       // setSelectedOptionShow("Company/Brand");
  //       setSelectedBrandItems([newBrandItems[0].name]);
  //     }

  //     const newProductItems = filters?.products?.map((item) => {
  //       return { id: item?.customer_brand_product_id, name: item?.product_name };
  //     }) || [];
  //     setProductItems((prev) => [...newProductItems]);
  //      if (selectedOptionShow === "Product" && !selectedProductItems.length && newProductItems.length) {
  //          setSelectedProductItems([newProductItems[0].name]);
  //        }

  //     // set the customer geographies
  //     let geo = await getGeographies();
  //     const geographyIds = [
  //       ...new Set(customerSpecificLlms?.data.map((obj) => obj?.geography_id)),
  //     ];
  //     geo = geo?.data.filter((obj) => geographyIds.includes(obj?.id));
  //     setGeography(geo);

  //     // set customer geography markets

  //     let market = await getMarkets();
  //     const filtercustomeLlm = customerSpecificLlms?.data.filter(
  //       (obj) => obj?.geography_id === 1
  //     );
  //     const marketIds = [
  //       ...new Set(filtercustomeLlm.map((obj) => obj?.market_id)),
  //     ];
  //     market = market?.data.filter((obj) => marketIds.includes(obj?.id));
  //     setMarkets(market);

  //     if (brandProducts?.data && brandProducts?.data.length === 0) {
  //       dispatch(fetchBrandProducts(customerId));
  //     }

  //     if (brands?.data && brands?.data.length === 0) {
  //       dispatch(fetchBrands(customerId));
  //     }

  //     // const llms = await getLlms();
  //     // setDbLlms(llms?.data);
  //   }

  //   fetchData();
  // }, []);

  useEffect(() => {
    async function fetchData() {
      const selectedBrandCustomerId = customerId;

      const customerSpecificLlms = await fetchCustomerLlms([
        Number(selectedBrandCustomerId),
      ]);
      setCustomerLlm(customerSpecificLlms?.data);

      const inputFilters = await getCustomerMonitoringFiletrs(customerId);

      let filters = {
        ...inputFilters,
        brands: [...(inputFilters?.brands || [])],
        products: [...(inputFilters?.products || [])],
      };
      setMonitoringFilters(filters);

      /* -----------------------------
       * Brand / Product bootstrap
       * ----------------------------- */
      const brandItems = filters?.brands?.map(b => ({
        id: b.customer_brand_id,
        name: b.brand_name,
      })) || [];
      setBrandItems(brandItems);

      if (!selectedBrandItems.length && brandItems.length) {
        setSelectedBrandItems([brandItems[0].name]);
      }

      const productItems = filters?.products?.map(p => ({
        id: p.customer_brand_product_id,
        name: p.product_name,
      })) || [];
      setProductItems(productItems);

      /* -----------------------------
       * 🔹 LLM + PROVIDER LOGIC
       * ----------------------------- */
      const categories =
        selectedOptionShow === "Product"
          ? filters?.products?.[0]?.categories
          : filters?.brands?.[0]?.categories;

      const llms = categories?.[0]?.llms || [];
      setDbLlms(llms);

      if (!llms.length) return;

      // 1️⃣ Pick default LLM
      const defaultLlm =
        llms.find(l => l.name === "gpt-4o") || llms[0];

      const selectedLlmName =
        selectedLlmItems?.[0] || defaultLlm.name;

      const selectedLlm = llms.find(l => l.name === selectedLlmName) || defaultLlm;

      // 2️⃣ Resolve provider
      const provider = selectedLlm.llm_provider || "Other";
      setSelectedLlmProviders([provider]);

      // 3️⃣ Select all LLMs from same provider
      const allLlmsFromProvider = llms
        .filter(l => (l.llm_provider || "Other") === provider)
        .map(l => l.name);

      setSelectedLlmItems(allLlmsFromProvider);

      // 4️⃣ Resolve market + geo (default-safe)
      const geography =
        categories?.[0]?.geographies || [];
      const markets =
        categories?.[0]?.markets || [];

      setGeography(geography);
      setMarkets(markets);

      const geoId = geography?.[0]?.id;
      const marketId = markets?.[0]?.id;

      // 5️⃣ Resolve customer LLM IDs (IMPORTANT)
      const providerLlmIds = llms
        .filter(l => allLlmsFromProvider.includes(l.name))
        .map(l => l.id);

      const customerLlmIds =
        customerSpecificLlms?.data
          ?.filter(item =>
            providerLlmIds.includes(item.llm_id) &&
            item.market_id === marketId &&
            item.geography_id === geoId
          )
          ?.map(item => item.id) || [];

      window.__initialCustomerLlmIds = customerLlmIds;

      /* -----------------------------
       * Lazy loads
       * ----------------------------- */
      if (brandProducts?.data?.length === 0) {
        dispatch(fetchBrandProducts(customerId));
      }
      if (brands?.data?.length === 0) {
        dispatch(fetchBrands(customerId));
      }
    }

    fetchData();
  }, []);



  // ----- helpers to mirror Dashboard.js derivation -----
    const productSpec = {
 root: () => monitoringFiletrs?.products,
      key: "product_name",
        defaultGeoField: "customer_product_geo",
        };
const brandSpec = {
root: () => monitoringFiletrs?.brands,
    key: "brand_name",
      defaultGeoField: "customer_brand_geo",
      };
const pickEntity = (spec, selectedNames) => {
    const root = spec.root() || [];
    return root.find((item) => selectedNames?.includes(item?.[spec.key]));
  };
const categoryListFrom = (entity) =>
    entity?.categories?.map((c) => ({ id: c?.categoryId, name: c?.categoryName })) ?? [];
const deriveByCategory = (entity, categoryName) => {
    const cat = entity?.categories?.find((c) => c?.categoryName === categoryName);
    return {
 geography: cat?.geographies ?? [],
        markets: cat?.markets ?? [],
          persona: cat?.personas ?? [],
            llms: cat?.llms ?? [],
            };
};

  const currentSpec = useMemo(() => {
    const useProduct = selectedOptionShow === "Product" && selectedProductItems?.length > 0;
    return useProduct ? productSpec : brandSpec;
  }, [selectedOptionShow, selectedProductItems, selectedBrandItems]);

  const currentEntity = useMemo(() => {
    if (!monitoringFiletrs) return null;
    const useProduct = selectedOptionShow === "Product" && selectedProductItems?.length > 0;
    const selectedNames = useProduct ? selectedProductItems : selectedBrandItems;
    return pickEntity(currentSpec, selectedNames);
  }, [monitoringFiletrs, selectedOptionShow, selectedProductItems, selectedBrandItems, currentSpec]);

  const categoriesForEntity = useMemo(() => {
    if (!currentEntity) return [];
    return categoryListFrom(currentEntity);
  }, [currentEntity]);

  useEffect(() => {
    if (!monitoringFiletrs || !currentEntity) return;

    // 1) categories
    const cats = categoriesForEntity;
    setCategories(cats);

    // preserve prior category if still valid, else first
    const prevCategoryName = selectedCategory?.[0];
    const hasPrev = cats?.some(c => c.name === prevCategoryName);
    const nextCatName = hasPrev ? prevCategoryName : cats?.[0]?.name;
    const nextCatId = hasPrev ? selectedCategoryIds?.[0] : cats?.[0]?.id;

    if (nextCatName) setSelectedCategory([nextCatName]);
    if (nextCatId) setSelectedCategoryIds([nextCatId]);

    // 2) derive lists under that category
    const { geography: geo, markets: mkts, persona: ppl, llms } = deriveByCategory(currentEntity, nextCatName);
    setDbLlms(llms || []);
    setGeography(geo || []);
    setMarkets(mkts || []);
    setPersonas(ppl || []);

    // 3) sensible fallbacks that keep previous when still valid
    const defaultGeoObj = currentEntity?.[currentSpec.defaultGeoField];

    // setSelectedLlmItems(prev => {
    //   const p = prev?.[0];
    //   const ok = (llms || []).some(x => x?.name === p);
    //   const fb = (llms || [])[0]?.name || "gpt-4o";
    //   return [ok ? p : fb].filter(Boolean);
    // });
    setSelectedLlmItems(prevSelected => {
      const selectedName = prevSelected?.[0];
      const existsInLlms = llms?.some(p => p.name === selectedName);
      const newName = existsInLlms ? selectedName : "gpt-4o";
      // Update provider based on selected LLM
      const selectedLlm = llms?.find(llm => llm.name === newName);
      if (selectedLlm) {
        setSelectedLlmProviders([selectedLlm.llm_provider || "Other"]);
      }
      return [newName]
    });

    setSelectedMarketItems(prev => {
      const p = prev?.[0];
      const ok = (mkts || []).some(x => x?.name === p);
      const fb = (mkts || [])[0]?.name;
      return [ok ? p : fb].filter(Boolean);
    });

    setSelectedGeographyItems(prev => {
      const p = prev?.[0];
      if ((geo || []).some(g => g?.name === p)) return [p];
      const fb = (geo || []).some(g => g?.name === defaultGeoObj?.name)
        ? defaultGeoObj?.name
        : (geo || [])[0]?.name;
      return [fb].filter(Boolean);
    });

    setSelectedPersona(prev => {
      const p = prev?.[0] ?? "General Persona";
      const ok = (ppl || []).some(x => x?.name === p);
      const fb = (ppl || [])[0]?.name;
      return [ok ? p : fb].filter(Boolean);
    });
    setTimeout(() => {
              setIsFirstTime(false);

              }, 3000);
  }, [
    monitoringFiletrs,
    currentEntity,
    categoriesForEntity,
    currentSpec,
  ]);
  



  useEffect(() => {
    if (!monitoringFiletrs || !selectedCategory?.length) return;

    const useProduct = selectedOptionShow === "Product" && selectedProductItems?.length > 0;
    const spec = useProduct ? productSpec : brandSpec;
    const names = useProduct ? selectedProductItems : selectedBrandItems;
    const entity = pickEntity(spec, names);
    if (!entity) return;

    const catName = selectedCategory[0];
    const { geography: geo, markets: mkts, persona: ppl, llms } = deriveByCategory(entity, catName);

    setDbLlms(llms || []);
    setGeography(geo || []);
    setMarkets(mkts || []);
    setPersonas(ppl || []);

    const defaultGeoObj = entity?.[spec.defaultGeoField];

    // same keep-or-fallback logic as above...
    // (setSelectedLlmItems / setSelectedMarketItems / setSelectedGeographyItems / setSelectedPersona)
    // setSelectedLlmItems(prev => {
    //   const p = prev?.[0];
    //   const ok = (llms || []).some(x => x?.name === p);
    //   const fb = (llms || [])[0]?.name || "gpt-4o";
    //   return [ok ? p : fb];
    // });
    setSelectedLlmItems(prevSelected => {
      const selectedName = prevSelected?.[0];
      const existsInLlms = llms?.some(p => p.name === selectedName);
      const newName = existsInLlms ? selectedName : "gpt-4o";
      // Update provider based on selected LLM
      const selectedLlm = llms?.find(llm => llm.name === newName);
      if (selectedLlm) {
        setSelectedLlmProviders([selectedLlm.llm_provider || "Other"]);
      }
      return [newName]
    });

    setSelectedMarketItems(prev => {
      const p = prev?.[0];
      const ok = (mkts || []).some(x => x?.name === p);
      const fb = (mkts || [])[0]?.name;
      return [ok ? p : fb];
    });

    setSelectedGeographyItems(prev => {
      const p = prev?.[0];
      if ((geo || []).some(g => g?.name === p)) return [p];
      const fb = (geo || []).some(g => g?.name === defaultGeoObj?.name)
        ? defaultGeoObj?.name
        : (geo || [])[0]?.name;
      return [fb];
    });

    setSelectedPersona(prev => {
      const p = prev?.[0] ?? "General Persona";
      const ok = (ppl || []).some(x => x?.name === p);
      const fb = (ppl || [])[0]?.name;
      return [ok ? p : fb];
    });
  }, [selectedCategory]);


    const handleCategoryCheckChange = (selected) => {
        if (!selected?.length) return;
        const names = selected.map((o) => o?.name ?? o?.categoryName ?? o);
        const latest = names[names.length - 1];
        setSelectedCategory([latest]);
    
          // Keep IDs in sync if options carry them
          const id =
              categories?.find((c) => c.name === latest)?.id ??
              selected?.find((s) => s?.id)?.id;
        if (id !== undefined) setSelectedCategoryIds([id]);
      };

  const shouldShowLoader = () => {
    const hasRequiredSelections =
      (selectedOptionShow === "Product"
        ? inputValidation.selectedProductItems
        : inputValidation.selectedBrandItems) &&
      inputValidation.selectedPersona &&
      inputValidation.selectedGeographyItems &&
      inputValidation.selectedMarketItems &&
      inputValidation.selectedCategory &&
      inputValidation.selectedLlmItems;

    // return ((!showData && !isDone && hasRequiredSelections) || isFirstTime);
    return hasStarted && hasRequiredSelections && (isLoading || jobStatus === "running" || jobStatus === "pending");
      };

  const getInputIds = () => {
    const brandId =
      brandItems?.filter((item) => item?.name === selectedBrandItems[0])[0]
        ?.id || null;

    const productId =
      productItems?.filter((item) => item?.name === selectedProductItems[0])[0]
        ?.id || null;

    const brandIds = brandItems
      ?.filter((item) => selectedBrandItems.includes(item?.name))
      .map((obj) => obj?.id);

    const productIds = productItems
      ?.filter((item) => selectedProductItems.includes(item?.name))
      .map((obj) => obj?.id);

    const globalLlmId = dbLlms?.filter(
      (item) => item?.name === selectedLlmItems[0]
    )[0]?.id;
    const marketId = markets?.filter(
      (item) => item?.name === selectedMarketItems[0]
    )[0]?.id;

    const geoId = geography?.filter(
      (item) => item?.name === selectedGeographyItems[0]
    )[0]?.id;

    const llmId = customerLlm?.filter(
      (item) =>
        item?.llm_id === globalLlmId &&
        item?.market_id === marketId &&
        item?.geography_id === geoId
    )[0]?.id;
    const personaId = personas
      ?.filter((item) => selectedPersona.includes(item?.name))
      .map((obj) => obj?.id);

    return {
      brandId,
      brandIds,
      productId,
      productIds,
      globalLlmId,
      llmId,
      personaId,
    };
  };

  const getCustomerLlmInputIds = () => {
    const llmIds = dbLlms
      .filter((item) => selectedLlmItems.includes(item?.name))
      .map((obj) => obj?.id);

    const marketIds = markets
      .filter((item) => selectedMarketItems.includes(item?.name))
      .map((obj) => obj?.id);

    const geoIds = geography
      .filter((item) => selectedGeographyItems.includes(item?.name))
      .map((obj) => obj?.id);

    const customerLlmIds = customerLlm
      .filter(
        (item) =>
          llmIds.includes(item?.llm_id) &&
          marketIds.includes(item?.market_id) &&
          geoIds.includes(item?.geography_id)
      )
      .map((obj) => obj?.id);

    return customerLlmIds;
  };

    const handleClickShow = async (isMetaRefresh) => {
        const error = handleInputValidation(
          selectedOptionShow,
          selectedBrandItems,
          selectedProductItems,
          selectedPersona,
          selectedFrequencyItems,
          value,
          selectedSubFrequencyItems,
          selectedLlmItems,
          selectedGeographyItems,
          selectedMarketItems,
          selectedCategory
        );
    
    
    
        if (error) {
          toast.error(error, {
            autoClose: 700,
          });
          return;
        }
      };

    const updateMonitoringDateList = async (brandId, productId, categoryIds, llmIds, personaIds, type) => {
        const payload = {
          productId, categoryIds, llmIds,
          personaIds, brandId, type, customerId, isCompanyUser
        }
        const dates = await getCustomerMonitoringDates(customerId, payload)
        // setAvailabelDates(selectedOptionShow === 'Product' ? dates?.productDates : dates?.brandDates)
        return selectedOptionShow === 'Product' ? dates?.productDates : dates?.brandDates
      }

  

  // const handleStartEdit = (tpl) => {
  //   // Store current sequence before editing starts
  //   setPreEditSequence([...activeSequence]);

  //   // Load the template's configuration for editing
  //   const loadTemplateForEdit = async () => {
  //     try {
  //       const template = await ReportTemplateService.getTemplate(tpl.id, user?.user_role?.user_id);
  //       if (template.config_data && Array.isArray(template.config_data)) {
  //         setActiveSequence(template.config_data);
  //         setEditingTemplate(tpl);
  //         setSelectedTemplateInfo({ id: tpl.id, name: tpl.template_name });
  //         toast.info(`Edit mode: "${tpl.template_name}"`);
  //       } else {
  //         toast.error('Failed to load template configuration');
  //       }
  //     } catch (error) {
  //       toast.error('Failed to load template for editing');
  //       console.error('Edit template load error:', error);
  //     }
  //   };

  //   loadTemplateForEdit();
  // };


  // const handleCancelEdit = () => setEditingTemplate(null);

  // const handleStartEdit = async (tpl) => {
  //   try {
  //     setEditingTemplate(tpl);
  //     setSelectedTemplateInfo({ id: tpl.id, name: tpl.template_name, description: tpl.description });

  //     // Load the template's configuration
  //     const template = await ReportTemplateService.getTemplate(tpl.id, user?.user_role?.user_id);
  //     if (template.config_data && Array.isArray(template.config_data)) {
  //       setActiveSequence(template.config_data);
  //       setOriginalTemplateSequence(JSON.parse(JSON.stringify(template.config_data)));
  //       toast.info(`Edit mode: "${tpl.template_name}"`); // Optional: confirm edit mode
  //       setIsChecked(!!template.show_change_data);
  //     }
  //   } catch (error) {
  //     toast.error('Failed to load template for editing');
  //     console.error('Edit template load error:', error);
  //   }
  // };

  const handleStartEdit = async (tpl) => {
    try {
      setEditingTemplate(tpl);
      setSelectedTemplateInfo({
        id: tpl.id,
        name: tpl.template_name,
        description: tpl.description,
        user_id: tpl.user_id,
        is_system: tpl.is_system,
        can_edit: tpl.can_edit,
        can_delete: tpl.can_delete
      });

      const template = await ReportTemplateService.getTemplate(tpl.id, user?.user_role?.user_id);
      if (template.config_data && Array.isArray(template.config_data)) {
        setActiveSequence(template.config_data);
        setOriginalTemplateSequence(JSON.parse(JSON.stringify(template.config_data)));
        setIsChecked(!!template.show_change_data); // ✅ Set checkbox
        setOriginalIsChecked(!!template.show_change_data); // ✅ Set baseline
        toast.info(`Edit mode: "${tpl.template_name}"`);
      }
    } catch (error) {
      toast.error('Failed to load template for editing');
      console.error('Edit template load error:', error);
    }
  };

  const handleCancelEdit = () => {
    if (preEditSequence) {
      // Restore the previous configuration
      setActiveSequence(preEditSequence);
      toast.info('Edit cancelled - restored previous configuration');
    }
    setEditingTemplate(null);
    setPreEditSequence(null);
    setSelectedTemplateInfo(null);
  };

  // const handleUpdateTemplate = async () => {
  //   try {
  //     if (!editingTemplate?.id) return;
  //     // Update only config_data; name/description unchanged
  //     await ReportTemplateService.updateTemplate(editingTemplate.id, {
  //       config_data: activeSequence,
  //       user_id: user?.user_role?.user_id
  //     });
  //     toast.success(`Updated "${editingTemplate.template_name}"`);
  //     setEditingTemplate(null);
  //   } catch (e) {
  //     toast.error(e?.response?.data?.error || 'Failed to update template');
  //   }
  // };

  const handleUpdateTemplate = async () => {
    try {
      if (!editingTemplate?.id) return;

      // Update only config_data; name/description unchanged
      await ReportTemplateService.updateTemplate(editingTemplate.id, {
        config_data: activeSequence,
        user_id: user?.user_role?.user_id
      });

      toast.success(`Updated "${editingTemplate.template_name}"`);

      // Keep the updated configuration active and clear edit state
      setEditingTemplate(null);
      setPreEditSequence(null);
      // Keep selectedTemplateInfo to show which template is active

    } catch (err) {
      toast.error(err.message || 'Failed to update template');
    }
  };


  // Check if all items in a section are active
  const isSectionFullyActive = (sectionId) => {
    const section = activeSequence.find(s => s.id === sectionId);
    if (!section || !section.config || section.config.length === 0) return false;
    return section.config.every(item => item.is_active);
  };

  // Check if any items in a section are active
  const isSectionPartiallyActive = (sectionId) => {
    const section = activeSequence.find(s => s.id === sectionId);
    if (!section || !section.config || section.config.length === 0) return false;
    return section.config.some(item => item.is_active);
  };

  // Toggle entire section on/off
  const handleSectionToggle = (sectionId) => {
    const isCurrentlyFullyActive = isSectionFullyActive(sectionId);

    setActiveSequence(prevSequence =>
      prevSequence.map(section => {
        if (section.id === sectionId) {
          return {
            ...section,
            config: section.config.map(item => ({
              ...item,
              is_active: !isCurrentlyFullyActive // If fully active, turn all off; otherwise turn all on
            }))
          };
        }
        return section;
      })
    );
  };


  useEffect(() => {
      // setShowData(false);
      // setIsDone(false);
      const handler = setTimeout(async () => {
        if (selectedSubFrequencyItems === "Custom") {
          const customerLlmIds = getCustomerLlmInputIds();
          const { brandId, productId, personaId } = getInputIds();
          const dates = await updateMonitoringDateList(brandId, productId, selectedCategoryIds, customerLlmIds, personaId, selectedOptionShow)
          if (JSON.stringify(availableDates) === JSON.stringify(dates)) {
  
            handleClickShow()
          } else {
            setAvailableDates(dates)
          }
        } else {
          if (
            selectedPersona.length &&
            (selectedBrandItems.length || selectedProductItems.length) &&
            !isFirstTime
          ) {
  
            handleClickShow();
            setIsFilterQuery(false);
          }
        }
  
      }, 300);
  
      return () => clearTimeout(handler);
    }, [
      selectedPersona,
      selectedGeographyItems,
      selectedMarketItems,
      selectedLlmItems,
      selectedSubFrequencyItems,
      customDateFilter,
    selectedCategory,
    selectedOptionShow
    ]);

    const handleProductTabSelect = () => {
      // if (selectedOptionShow === "Product") {
        const defaultGeography = monitoringFiletrs?.products?.[0]?.customer_product_geo
        const geography = monitoringFiletrs?.products?.[0]?.categories?.[0]?.geographies;
        const markets = monitoringFiletrs?.products?.[0]?.categories?.[0]?.markets;
        const persona = monitoringFiletrs?.products?.[0]?.categories?.[0]?.personas;
        const llms = monitoringFiletrs?.products?.[0]?.categories?.[0]?.llms;
        const category = monitoringFiletrs?.products?.[0]?.categories?.map((item) => {
          return { id: item?.categoryId, name: item?.categoryName };
        });
        const categoryIds = [category?.[0]?.id] || null;
        const generalPersona = persona?.find(p => p.name === "General Persona");

        const brandProductId =
          monitoringFiletrs?.products?.[0]?.customer_brand_product_id || null;
        const personaId = [
          generalPersona?.id ||
          persona?.[0]?.id
        ];
        const globalLlmId = 1;
        const marketId = markets?.[0]?.id;
        const geoId = geography?.some(obj => obj.name === defaultGeography?.name) ? defaultGeography?.id : geography?.[0]?.id;
        const llmId = customerLlm?.filter(
          (item) =>
            item?.llm_id === globalLlmId &&
            item?.market_id === marketId &&
            item?.geography_id === geoId
        )[0]?.id;

        const productName = monitoringFiletrs?.products?.[0]?.product_name;
        // const generalPersona = persona?.find(p => p.name === "General Persona");


        setDbLlms(llms);
        setGeography(geography);
        setMarkets(markets);
        setSelectedProductItems([monitoringFiletrs?.products?.[0]?.product_name]);
        // setSelectedPersona([persona?.[0]?.name]);
        setSelectedPersona([
          generalPersona?.name || persona?.[0]?.name
        ]);
        // setSelectedLlmItems(['gpt-4o']);
      setSelectedLlmItems(prevSelected => {
        const selectedName = prevSelected?.[0];
        const existsInLlms = dbLlms?.some(p => p.name === selectedName);
        const newName = existsInLlms ? selectedName : "gpt-4o";
        // Update provider based on selected LLM
        const selectedLlm = dbLlms?.find(llm => llm.name === newName);
        if (selectedLlm) {
          setSelectedLlmProviders([selectedLlm.llm_provider || "Other"]);
        }
        return [newName];
      });
        setSelectedMarketItems([markets?.[0]?.name]);
        setSelectedGeographyItems([geography?.some(obj => obj.name === defaultGeography?.name) ? defaultGeography?.name : geography?.[0]?.name]);
        setProductItems(
          monitoringFiletrs?.products?.map((item) => {
            return {
              id: item?.customer_brand_product_id,
              name: item?.product_name,
            };
          })
        );
        setPersonas(persona);
        setCategories(category);
        setSelectedCategory([category?.[0]?.name]);
        setSelectedCategoryIds(categoryIds);
    }

    const handleBrandTabClick = () => {
      // if (selectedOptionShow === "Company/Brand") {
        const defaultGeography = monitoringFiletrs?.brands?.filter((item) =>
          selectedBrandItems.includes(item?.brand_name)
        )?.[0]?.customer_brand_geo
        const geography = monitoringFiletrs?.brands?.filter((item) =>
          selectedBrandItems.includes(item?.brand_name)
        )?.[0]?.categories?.[0]?.geographies;
        const markets = monitoringFiletrs?.brands?.filter((item) =>
          selectedBrandItems.includes(item?.brand_name)
        )?.[0]?.categories?.[0]?.markets;
        const persona = monitoringFiletrs?.brands?.filter((item) =>
          selectedBrandItems.includes(item?.brand_name)
        )?.[0]?.categories?.[0]?.personas;
        const llms = monitoringFiletrs?.brands?.filter((item) =>
          selectedBrandItems.includes(item?.brand_name)
        )?.[0]?.categories?.[0]?.llms;
        const category = monitoringFiletrs?.brands
          ?.filter((item) =>
            selectedBrandItems?.includes(item?.brand_name)
          )?.[0]
          ?.categories?.map((item) => {
            return { id: item?.categoryId, name: item?.categoryName };
          });
        const categoryIds = [category?.[0]?.id] || null;

        setDbLlms(llms);
        setGeography(geography);
        setMarkets(markets);
        setPersonas(persona);
        setCategories(category);
        // setSelectedLlmItems(['gpt-4o']);
        // setSelectedMarketItems([markets?.[0]?.name]);
        // setSelectedGeographyItems([geography?.some(obj => obj.name === defaultGeography?.name) ? defaultGeography?.name : geography?.[0]?.name]);
        setSelectedLlmItems(prevSelected => {
          const selectedName = prevSelected?.[0];
          const existsInLlms = llms?.some(p => p.name === selectedName);
          const newName = existsInLlms ? selectedName : "gpt-4o";
          // Update provider based on selected LLM
          const selectedLlm = dbLlms?.find(llm => llm.name === newName);
          if (selectedLlm) {
            setSelectedLlmProviders([selectedLlm.llm_provider || "Other"]);
          }
          return [newName]
        });
        setSelectedMarketItems(prevSelected => {
          const selectedName = prevSelected?.[0];
          const existsInMarkets = markets?.some(p => p.name === selectedName);
          const newName = existsInMarkets ? selectedName : markets?.[0]?.name;
          return [newName];
        });
        setSelectedGeographyItems(prevSelected => {
          const selectedName = prevSelected?.[0];

          if (geography?.some(g => g.name === selectedName)) {
            return [selectedName];
          }

          const fallbackName = geography?.some(g => g.name === defaultGeography?.name)
            ? defaultGeography?.name
            : geography?.[0]?.name;

          return [fallbackName];
        });

        setSelectedPersona(prevSelected => {
          const selectedName = prevSelected?.[0];
          const existsInPersona = persona?.some(p => p.name === selectedName);
          const newName = existsInPersona ? selectedName : persona?.[0]?.name;
          return [newName];
        });

        // setSelectedCategory([category?.[0]?.name]);
        // setSelectedCategoryIds(categoryIds);

        const isCategoryTab = activeTab === "category";
        if (isCategoryTab) {
          setSelectedCategory(category.map((obj) => obj?.name));
          setSelectedCategoryIds(category.map((obj) => obj?.id));
        } else {
          setSelectedCategory(prevSelected => {
            const selectedName = prevSelected?.[0];
            const existsInCategory = category?.some(p => p.name === selectedName);
            const newName = existsInCategory ? selectedName : category?.[0]?.name;
            return [newName];
          });
          setSelectedCategoryIds(prevSelected => {
            const selectedId = prevSelected?.[0];
            const existsInCategoryId = category?.some(p => p.id === selectedId);
            const newId = existsInCategoryId ? selectedId : category?.[0]?.id;
            return [newId];
          });
        }
      // }
    }
    

  const handleDragEnd = (result) => {
    if (!result.destination) return; // If dropped outside the list, do nothing

    const { source, destination } = result;

    // Find the parent container (sequence) of the dragged item
    const updatedSequence = [...activeSequence];

    const parentIndex = updatedSequence.findIndex((seq) =>
      seq.config.some((item) => String(item.id) === result.draggableId)
    );

    if (parentIndex === -1) return; // No valid parent found

    // Clone the config array of the identified sequence
    const updatedConfig = Array.from(updatedSequence[parentIndex].config);

    // Reorder the dragged item within its sequence
    const [movedItem] = updatedConfig.splice(source.index, 1);
    updatedConfig.splice(destination.index, 0, movedItem);

    // Update the sequence with the new config order
    updatedSequence[parentIndex] = {
      ...updatedSequence[parentIndex],
      config: updatedConfig,
    };

    setActiveSequence(updatedSequence); // Update the state with new order
  };

  const handleEnableDisable = (sectionId, itemId) => {
    setActiveSequence((prevConfigs) =>
      prevConfigs.map((section) => {
        if (section.id === sectionId) {
          return {
            ...section,
            config: section.config.map((item) =>
              item.id === itemId
                ? { ...item, is_active: !item.is_active }
                : item
            ),
          };
        }
        return section;
      })
    );
  };

  // Helper function to check if configurations have changed
  // const hasConfigurationChanged = () => {
  //   // Get the baseline to compare against
  //   const baseline = originalTemplateSequence ||
  //     (selectedOptionShow === "Product" ? initialProdTabs : initialBrandTabs);

  //   // Deep comparison of activeSequence with baseline
  //   return JSON.stringify(activeSequence) !== JSON.stringify(baseline);
  // };

  // Helper function to check if configurations have changed
  const hasConfigurationChanged = () => {
    const baseline = originalTemplateSequence ||
      (selectedOptionShow === "Product" ? initialProdTabs : initialBrandTabs);

    const sequenceChanged = JSON.stringify(activeSequence) !== JSON.stringify(baseline);
    const checkboxChanged = isChecked !== originalIsChecked;

    return sequenceChanged || checkboxChanged;
  };

  // Check if Quick Save should be enabled
  // const isQuickSaveEnabled = hasConfigurationChanged() && !editingTemplate;
  const isSystemTemplate = selectedTemplateInfo?.is_system;
  const isQuickSaveEnabled = hasConfigurationChanged() && !isBusy && !isSystemTemplate;

  const handleLoadTemplate = (loadedSequence, templateInfo = null) => {
    if (!loadedSequence || !Array.isArray(loadedSequence)) {
      toast.error('Invalid template configuration');
      return;
    }

    try {
      setActiveSequence(loadedSequence);
      setIsChecked(!!templateInfo?.show_change_data);
      setOriginalIsChecked(!!templateInfo?.show_change_data);
      setSelectedTemplateInfo(templateInfo); // Store template info for the chip
      setOriginalTemplateSequence(JSON.parse(JSON.stringify(loadedSequence)));
      setEditingTemplate(null);
      setPreEditSequence(null);
      toast.success('Template configuration applied');
    } catch (err) {
      toast.error('Failed to apply template');
      console.error('Template load error:', err);
    }
  };

  // One-shot download when we first see success for a given jobId
  useEffect(() => {
    if (jobStatus === "completed" && jobId && downloadedForJobRef.current !== jobId) {

      // Show success message before download
      toast.success('Report generated successfully!', {
        autoClose: 3000,
      });

    }
  }, [jobStatus, jobId]);

  const handleQuickSave = async () => {
    if (!selectedTemplateInfo?.id) {
      toast.error('No template selected');
      return;
    }

    try {
      setLoading(true);
      await ReportTemplateService.updateTemplate(selectedTemplateInfo.id, {
        config_data: activeSequence,
        user_id: user?.user_role?.user_id
      });

      // Update the original sequence to the newly saved state
      setOriginalTemplateSequence(JSON.parse(JSON.stringify(activeSequence)));
      toast.success(`Quick saved "${selectedTemplateInfo.name}"`);
    } catch (error) {
      toast.error(error.message || 'Failed to quick save template');
    } finally {
      setLoading(false);
    }
  };

  const resetToInitialTabs = () => {
    const initialTabs = selectedOptionShow === "Product" ? initialProdTabs : initialBrandTabs;
    setActiveSequence(initialTabs);
    setSelectedTemplateInfo(null);
    setEditingTemplate(null);
    setPreEditSequence(null);
    setOriginalTemplateSequence(null);
    setIsChecked(false);
    setOriginalIsChecked(false); 
    toast.info('Reset to default configuration');
  };

  useEffect(() => {
    // Clear template selection when switching between Brand/Product
    setSelectedTemplateInfo(null);
    setEditingTemplate(null);
    setPreEditSequence(null);
    setOriginalTemplateSequence(null);
  }, [selectedOptionShow]);

  const handleSwitchChange = (sectionId, itemId, type = "summary") => {
    setActiveSequence((prevConfigs) =>
      prevConfigs.map((section) => {
        if (section.id === sectionId) {
          return type === "summary"
            ? {
              ...section,
              config: section.config.map((item) =>
                item.id === itemId
                  ? { ...item, generate_summary: !item.generate_summary }
                  : item
              ),
            }
            : {
              ...section,
              config: section.config.map((item) =>
                item.id === itemId
                  ? { ...item, show_change: !item.show_change }
                  : item
              ),
            };
        }
        return section;
      })
    );
  };

  const handleProductCheckChange = (selected) => {
    // let selectedValues = selected?.map((option) => option?.product?.name);
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );
    const latestValue = selectedValues[0];
    setSelectedProductItems(selectedValues || []);
    // setSelectedPersona([]);
    // const selectedProduct = brandProducts?.data?.data.filter(
    //   (data) => data?.product?.name === latestValue && data?.is_active
    // );

    // const persona = selectedProduct[0]?.custProduct;
    // setPersonas(persona);

    // personas/others will be derived by the recompute effect from monitoringFiletrs
    setSelectedPersona([]);
  };

  const handleBrandCheckChange = (selected) => {
    console.log("handleBrandCheckChange selected", selected);
    let selectedValues = selected?.map((option) => option?.name);
    let lastIndex = selectedValues.length - 1;
    console.log("before selectedValues", selectedValues);
    selectedValues = selectedValues?.filter(
      (item, index) => index === lastIndex
    );
    console.log("after selectedValues", selectedValues);
    const latestValue = selectedValues[0];

    setSelectedBrandItems(selectedValues || []);
    const selectedBrand = brands?.data?.data.filter(
      (data) => data?.brand?.name === latestValue && data?.is_active
    );
    const persona = selectedBrand[0]?.persona;
    setPersonas(persona);
  };

  const handlePersonaCheckChange = (selected) => {
    if (!selected.length) return;
    const selectedValues = selected?.map((option) => option?.name);
    const latestValue = selectedValues[selectedValues.length - 1];
    setSelectedPersona([latestValue] || []);
  };

  const handleGeographyCheckChange = async (selected) => {
    if (!selected.length) return;
    let selectedValues = selected?.map((option) => option?.name);
    const latestValue = selectedValues[selectedValues.length - 1];
    setSelectedGeographyItems([latestValue] || []);

    let geoId = geography.filter((obj) => obj?.name === latestValue)[0]?.id;
    let market = await getMarkets();
    const filtercustomeLlm = customerLlm.filter(
      (obj) => obj?.geography_id === geoId
    );

    if (selectedValues && selectedValues.length === 1) {
      // set customer geography markets

      const marketIds = [
        ...new Set(filtercustomeLlm.map((obj) => obj?.market_id)),
      ];
      market = market?.data.filter((obj) => marketIds.includes(obj?.id));
      setMarkets(market);
    } else if (selectedValues && selectedValues.length > 1) {
      // set customer geography markets

      market = market?.data.filter((obj) => obj?.name === "General Market");
      setMarkets(market);
    }
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };


  const handlesubFrequencyCheckChange = (key) => {
    setSelectedSubFrequencyItems(key);
  };

  // const handleMarketCheckChange = (selected) => {
  //   let selectedValues = selected?.map((option) => option?.name);

  //   setSelectedMarketItems(selectedValues || []);
  // };

  const handleMarketCheckChange = (selected) => {
    if (shouldShowLoader()) return;
    let selectedValues = selected?.map((option) => option?.name) || [];
    const isMarketTab = value === 4;

    if (isMarketTab && selectedValues.length > 1) {
      // Market tab: if multiple markets selected, switch geography to single
      const generalLocation = geography?.find(
        (g) => g.name === "General Location"
      );
      const geoToSelect = generalLocation
        ? [generalLocation.name]
        : [geography?.[0]?.name];
      setSelectedGeographyItems(geoToSelect);
    } else if (!isMarketTab) {
      // Other tabs: only allow single market selection
      let lastIndex = selectedValues.length - 1;
      selectedValues = selectedValues?.filter(
        (item, index) => index === lastIndex
      );
    }

    setSelectedMarketItems(selectedValues || []);
  };

  // const handleLlmCheckChange = (selected) => {
  //   if (!selected.length) return;
  //   const index = selected.length - 1;
  //   const selectedValues = [selected[index].name] || [];
  //   setSelectedLlmItems(selectedValues || []);
  // };

  const handleLlmCheckChange = (selected) => {
    if (shouldShowLoader()) return;

    // Handle both single object (when allowMultipleProviders=false) and array (when allowMultipleProviders=true)
    const selectedArray = Array.isArray(selected) ? selected : (selected ? [selected] : []);

    // Extract provider names
    const selectedProviderValues = selectedArray.map((option) => option?.value);

    // For LLM tab (value === 3), allow multiple providers
    // For other tabs, only keep the last selected provider
    const isLlmTab = value === 3;
    const providersToUse = isLlmTab
      ? selectedProviderValues
      : selectedProviderValues.length > 0
        ? [selectedProviderValues.at(-1)]
        : [];

    // Extract all LLM names from selected providers
    const allLlmNames = [];
    selectedArray.forEach((providerOption) => {
      if (providersToUse.includes(providerOption.value)) {
        providerOption.llms?.forEach((llm) => {
          allLlmNames.push(llm.name);
        });
      }
    });

    setSelectedLlmProviders(providersToUse);
    setSelectedLlmItems(allLlmNames);
  };

  // const handleSubmitReporting = async () => {
  //   let interval;
  //   try {
  //     setLoading(true);
  //     const frontend_build_version = localStorage.getItem(
  //       "frontend_build_version"
  //     );
  //     const token = localStorage.getItem("token");
  //     const user = localStorage.getItem("user");
  //     const overview =
  //       activeSequence.find((o) => o.id === "overview")?.config || [];
  //     const category = activeSequence.find((o) => o.id === "category")?.config || [];
  //     const competition =
  //       activeSequence.find((o) => o.id === "competition")?.config || [];
  //     const llm = activeSequence.find((o) => o.id === "llm")?.config || [];
  //     const market =
  //       activeSequence.find((o) => o.id === "market")?.config || [];
  //     const persona =
  //       activeSequence.find((o) => o.id === "persona")?.config || [];

  //     const source =
  //       activeSequence.find((o) => o.id === "source")?.config || [];

  //     const actions = activeSequence.find((o) => o.id === "actions")?.config || [];

  //     const payload = {
  //       brand: selectedOptionShow === "Product" ? selectedProductItems?.[0] : selectedBrandItems?.[0],
  //       reporting_config: {
  //         overview,
  //         category,
  //         competition,
  //         llm,
  //         market,
  //         persona,
  //         source,
  //         actions
  //       },
  //       filter_config: {
  //         is_brand: selectedOptionShow !== "Product",
  //         llm: MONITORING_LLM_LABELS[selectedLlmItems?.[0]] || selectedLlmItems?.[0],
  //         market: selectedMarketItems?.[0],
  //         persona: selectedPersona?.[0],
  //         brand: selectedBrandItems?.[0],
  //         product: selectedProductItems?.[0],
  //         geography: selectedGeographyItems?.[0],
  //         category: selectedCategory?.[0],
  //         brand_product_name:
  //           selectedOptionShow === "Product"
  //             ? selectedProductItems?.[0]
  //             : selectedBrandItems?.[0],
  //         frequency: selectedSubFrequencyItems,
  //         showChangeData: isChecked,
  //       },
  //       frontend_build_version,
  //       token,
  //       user,
  //     };
  //     console.log(payload);
  //     // Start Mock Progress
  //     let progress = 0;
  //     interval = setInterval(() => {
  //       if (progress >= 99) {
  //         clearInterval(interval);
  //         return;
  //       }
  //       progress += 1; // Increase by 5% per second
  //       setPercentCompleted(progress);
  //     }, 1000);
  //     const blob = await api.post("/llm-reporting/generate", payload, {
  //       responseType: "blob",
  //     });
  //     const url = window.URL.createObjectURL(blob.data);
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = "reporting.pptx";
  //     document.body.appendChild(a);
  //     a.click();
  //     window.URL.revokeObjectURL(url);
  //     setLoading(false);
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setPercentCompleted(0);
  //     setLoading(false);
  //     clearInterval(interval);
  //   }
  // };

  const activeOnly = (id) =>
    (activeSequence.find((o) => o.id === id)?.config || []).filter((c) => c.is_active);

  const handleSubmitReporting = async () => {
    if (isBusy) return;
      try {
          inFlightRef.current = true;
          setHasStarted(true);
          setLoading(true);
          setPercentCompleted(1);
          setJobId(null);
          setJobStatus(null);
          setJobMessages([]);
        downloadedForJobRef.current = null;

        const frontend_build_version = localStorage.getItem(
          "frontend_build_version"
        );
        const token = localStorage.getItem("token");
        const user = localStorage.getItem("user");
        // const overview =
        //   activeSequence.find((o) => o.id === "overview")?.config || [];
        // const category = activeSequence.find((o) => o.id === "category")?.config || [];
        // const competition =
        //   activeSequence.find((o) => o.id === "competition")?.config || [];
        // const llm = activeSequence.find((o) => o.id === "llm")?.config || [];
        // const market =
        //   activeSequence.find((o) => o.id === "market")?.config || [];
        // const persona =
        //   activeSequence.find((o) => o.id === "persona")?.config || [];

        // const source =
        //   activeSequence.find((o) => o.id === "source")?.config || [];

        // const actions = activeSequence.find((o) => o.id === "actions")?.config || [];

        const overview = activeOnly("overview");
        const category = activeOnly("category");
        const competition = activeOnly("competition");
        const llm = activeOnly("llm");
        const market = activeOnly("market");
        const persona = activeOnly("persona");
        const source = activeOnly("source");
        const actions = activeOnly("actions");

        if(!overview.length && !category.length && !competition.length && !llm.length && !market.length && !persona.length && !source.length && !actions.length){
          setHasStarted(false);
          setLoading(false);
          setPercentCompleted(0);
          inFlightRef.current = false;
          toast.warn("Please select at least one tab");
          return
        }

        const payload = {
          brand: selectedOptionShow === "Product" ? selectedProductItems?.[0] : selectedBrandItems?.[0],
          reporting_config: {
            overview,
            category,
            competition,
            llm,
            market,
            persona,
            source,
            actions
          },
          filter_config: {
            is_brand: selectedOptionShow !== "Product",
            // llm: MONITORING_LLM_LABELS[selectedLlmItems?.[0]] || selectedLlmItems?.[0],
            llm: selectedLlmProviders?.[0],
            selected_llm_names: MONITORING_LLM_LABELS[selectedLlmItems?.[0]] || selectedLlmItems?.[0],
            market: selectedMarketItems?.[0],
            persona: selectedPersona?.[0],
            brand: selectedBrandItems?.[0],
            product: selectedProductItems?.[0],
            geography: selectedGeographyItems?.[0],
            category: selectedCategory?.[0],
            brand_product_name:
              selectedOptionShow === "Product"
                ? selectedProductItems?.[0]
                : selectedBrandItems?.[0],
            frequency: selectedSubFrequencyItems,
            showChangeData: isChecked,
            customer_id: customerId
          },
          frontend_build_version,
          token,
          user,
        };
      
            const { data } = await api.post("/llm-reporting/generate", payload);
          // backend returns { jobId }
            if (!data?.jobId) throw new Error("No jobId returned from server");
          setJobId(data.jobId);
          setJobStatus("pending");
      
            // begin polling every 10s
            pollProgress(data.jobId);
        } catch (error) {
            console.error(error);
        setJobStatus("failed");
            // toast.error(error?.message || "Failed to start report");
            } finally {
          setLoading(false);
        }
    };

  // const stopPolling = () => {
  //   if (pollTimerRef.current) {
  //     clearInterval(pollTimerRef.current);
  //     pollTimerRef.current = null;
  //   }

  //   if (initialPollTimerRef.current) {
  //     clearTimeout(initialPollTimerRef.current);
  //     initialPollTimerRef.current = null;
  //   }
  //   pollErrorCountRef.current = 0;
  //   inFlightRef.current = false;
  // };

  const stopPolling = () => {
    if (pollTimerRef.current) {
      clearTimeout(pollTimerRef.current);
      pollTimerRef.current = null;
    }
    if (initialPollTimerRef.current) {
      clearTimeout(initialPollTimerRef.current);
      initialPollTimerRef.current = null;
    }
    pollErrorCountRef.current = 0; // if you still keep it
    inFlightRef.current = false; // if you use a double-submit guard
  };


  const isTransientError = (err) => {
    if (!err || !err.response) return true; // network / timeout
    const { status } = err.response;
    // Treat 429/5xx as transient; optionally 404/409 if progress row/file isn't ready yet
    return status === 429 || (status >= 500 && status <= 599) || status === 404 || status === 409;
  };


  const fetchProgressOnce = async (id) => {
    const { data } = await api.get(`/llm-reporting/progress/${id}`);
    // data: { id, status, finalFilePath, totalSlides, generatedSlides, startDate, endDate, messages: [...] }
    setJobStatus(data.status);
    setJobMessages(Array.isArray(data.messages) ? data.messages : []);
    const p = Number(data?.percent ?? 1);
    setPercentCompleted(Math.max(1, Math.min(100, p)));
    return data;
  };

  // const pollProgress = (id) => {

  //   stopPolling();
    
  //     const run = async () => {
  //         try {
  //             const data = await fetchProgressOnce(id);
  //             pollErrorCountRef.current = 0; // reset on success
  //             handleTerminal(data);
  //           } catch (e) {
  //               // Swallow a couple of transient “not yet created” errors
  //                 pollErrorCountRef.current += 1;
  //               if (pollErrorCountRef.current >= 3) {
  //                   // after a few consecutive failures, give up
  //                     stopPolling();
  //                 }
  //             }
  //       };
    
  //     // small warm-up so backend can persist the job row/file
  //     initialPollTimerRef.current = setTimeout(() => {
  //         run(); // first hit after delay
  //         pollTimerRef.current = setInterval(run, 10000); // normal cadence
  //       }, 1200); // tweak (e.g., 800–2000ms) to taste

  // };

  const pollProgress = (id) => {
    stopPolling(); // clear previous timers

    let consecutiveFailures = 0;

    const scheduleNext = (delayMs) => {
      if (pollTimerRef.current) clearTimeout(pollTimerRef.current);
      pollTimerRef.current = setTimeout(run, delayMs);
    };

    const run = async () => {
      try {
        const data = await fetchProgressOnce(id);
        consecutiveFailures = 0;               // reset on success
        handleTerminal(data);
        if (data.status === "running" || data.status === "pending") {
          // 🔴 changed from 10000 → 15000
          scheduleNext(15000);
        }
      } catch (err) {
        const transient = isTransientError(err);
        consecutiveFailures += 1;

        if (!transient || consecutiveFailures >= 3) {
          stopPolling();
          setJobStatus("failed");
          return;
        }

        // transient retry with exponential backoff
        const base = 800 * Math.pow(2, consecutiveFailures - 1);
        const jitter = Math.floor(Math.random() * 200);
        scheduleNext(base + jitter);
      }
    };

    // warm-up (first call delayed a little)
    initialPollTimerRef.current = setTimeout(run, 1200);
  };


  // const handleTerminal = (data) => {
  //   if (!data) return;
  //   if (data.status === "success") {
  //     setPercentCompleted(100);
  //     stopPolling();
  //     downloadJob(data.id).catch(() => { });
  //     setHasStarted(false);
  //     inFlightRef.current = false;
  //   } else if (data.status === "failed") {
  //     stopPolling();
  //     setHasStarted(false);
  //     inFlightRef.current = false;
  //   }
  // };

   const handleTerminal = (data) => {
       if (!data) return;
       if (data.status === "success" || data.status === "completed") {
           setPercentCompleted(100);
           stopPolling();
           setHasStarted(false);
           inFlightRef.current = false;
           // no direct download here
           } else if (data.status === "failed") {
               stopPolling();
               setHasStarted(false);
               inFlightRef.current = false;
             }
     };

  const handleTemplateDeleted = (deletedTemplateId) => {
    // Check if the deleted template is currently active
    if (selectedTemplateInfo?.id === deletedTemplateId) {
      resetToInitialTabs();
      // toast.info('Active template was deleted. Reset to default configuration.');
    }
  };
  
     // One-shot download when we first see success for a given jobId
     useEffect(() => {
         if (jobStatus === "completed" && jobId && downloadedForJobRef.current !== jobId) {
             downloadedForJobRef.current = jobId; // mark as done
             try {
                 downloadJob(jobId);
               } catch { }
           }
       }, [jobStatus, jobId]);


  // const downloadJob = async (id) => {
  //   const resp = await api.get(`/llm-reporting/download/${id}`, { responseType: "blob" });
  //   const url = window.URL.createObjectURL(resp.data);
  //   const a = document.createElement("a");
  //   a.href = url;
  //   a.download = "reporting.pptx";
  //   document.body.appendChild(a);
  //   a.click();
  //   window.URL.revokeObjectURL(url);
  // };

  //  const buildApiUrl = (path) => {
  //      const base = (api?.defaults?.baseURL || "").replace(/\/$/, "");
  //      return `${base}${path}`;
  //    };
  
  //    // Let the browser follow 302 → SAS and download natively (no CORS, no blobs)
  //    const downloadJob = (id) => {
  //        const url = buildApiUrl(`/llm-reporting/download/${id}`);
  //        // Option A: same-tab navigation (recommended)
  //          window.location.assign(url);
  //        // Option B: new tab — uncomment if you prefer not to leave the page
  //          // window.open(url, "_blank", "noopener,noreferrer");
  //        };

  const buildApiUrl = (path) => {
    const base = (api?.defaults?.baseURL || "").replace(/\/$/, "");
    return `${base}${path.startsWith("/") ? "" : "/"}${path}`;
  };

  const downloadJob = async (id, { filename, newTab = false } = {}) => {
    if (!id) return;
    const q = filename ? `?filename=${encodeURIComponent(filename)}` : "";
    const url = buildApiUrl(`/llm-reporting/download/${encodeURIComponent(id)}${q}`);

    // if (newTab) {
    //   const win = window.open(url, "_blank", "noopener,noreferrer");
    //   if (!win) {
    //     // popup blocked; anchor fallback
    //     const a = document.createElement("a");
    //     a.href = url;
    //     a.target = "_blank";
    //     a.rel = "noopener";
    //     document.body.appendChild(a);
    //     a.click();
    //     a.remove();
    //   }
    // } else {
    //   window.location.assign(url);
    // }
    const pptFileName = selectedOptionShow === "Company/Brand" ? 'brand-monitoring-report.pptx' : 'product-monitoring-report.pptx';
    
            // Use the downloadFile helper which includes authentication
            const result = await downloadFile(
              `/llm-reporting/download/${id}`,
              `${pptFileName}` // or whatever filename you want
            );
            if (!result.success) {
              toast.error(
                "Failed to download report. Please try again later."
              );
            } else if (result.success) {
              console.log("File downloaded successfully");
              toast.success("Report downloaded successfully");
            }
  };


  useEffect(() => {
    return () => stopPolling();
  }, []);

  const showProgressUI = hasStarted && (isLoading || jobStatus === "running" || jobStatus === "pending");

  const handleCancelClick = async () => {
    try {
      if (jobId) {
        await api.get(`/llm-reporting/cancel/${jobId}`);
      }
    } catch (e) {
      console.error("Cancel failed", e);
    }
    stopPolling();
    inFlightRef.current = false;
    setHasStarted(false);
    setLoading(false);
    setPercentCompleted(1);
    setJobId(null);
    setJobStatus(null);
    setJobMessages([]);
    downloadedForJobRef.current = null;
  }



  return (
    <div className="p-4 max-w-lg mx-auto">
      <nav className="customTabs">
        <div className="nav nav-tabs" id="nav-tab" role="tablist">
          <button
            className={`nav-link ${selectedOptionShow === "Company/Brand" ? "active" : ""
              }`}
            id="nav-configuration-tab"
            data-bs-toggle="tab"
            data-bs-target="#nav-configuration"
            type="button"
            role="tab"
            aria-controls="nav-home"
            aria-selected={selectedOptionShow === "Company/Brand"}
            onClick={() => {
              if(selectedOptionShow !== "Company/Brand") {

                setSelectedOptionShow((prev) => "Company/Brand")
                setActiveSequence(initialBrandTabs);
                setSelectedBrandItems([brandItems[0]?.name]);
                handleBrandTabClick();
              }
            }}
          >
            Institution
          </button>
          {/* <button
            className={`nav-link ${selectedOptionShow === "Product" ? "active" : ""
              }`}
            id="nav-configuration-tab"
            data-bs-toggle="tab"
            data-bs-target="#nav-configuration"
            type="button"
            role="tab"
            aria-controls="nav-home"
            aria-selected={selectedOptionShow === "Product"}
            onClick={() => {
              if(selectedOptionShow !== "Product") {

                setSelectedOptionShow((prev) => "Product")
                setActiveSequence(initialProdTabs);
                setSelectedProductItems([productItems[0]?.name]);
                handleProductTabSelect();
              }
            }}
          >
            Program
          </button> */}
        </div>
      </nav>
      <DashboardNav
        activeTab={activeTab}
        handleTabClick={handleTabClick} 
        selectedOptionShow={selectedOptionShow}
        brandItems={brandItems}
        selectedBrandItems={selectedBrandItems}
        handleBrandCheckChange={handleBrandCheckChange}
        handleProductCheckChange={handleProductCheckChange}
        selectedProductItems={selectedProductItems}
        productItems={productItems}
        inputValidation={inputValidation}
        isFirstTime={!!isFirstTime}
        selectedPersona={selectedPersona}
        handlePersonaCheckChange={handlePersonaCheckChange}
        personas={personas}
        handleCategoryCheckChange={handleCategoryCheckChange}
        selectedCategory={selectedCategory}
        categories={categories}
        selectedGeographyItems={selectedGeographyItems}
        handleGeographyCheckChange={handleGeographyCheckChange}
        geography={geography}
        selectedMarketItems={selectedMarketItems}
        handleMarketCheckChange={handleMarketCheckChange}
        markets={markets}
        selectedLlmItems={selectedLlmItems}
        selectedLlmProviders={selectedLlmProviders}
        handleLlmCheckChange={handleLlmCheckChange}
        dbLlms={dbLlms}
        selectedSubFrequencyItems={selectedSubFrequencyItems}
        handlesubFrequencyCheckChange={handlesubFrequencyCheckChange}
        showData={isReady() && !editingTemplate}
        // isDone={true}
        isDone={isReady() && !editingTemplate}
        handleClickShow={() => {
          handleSubmitReporting();
        }}
        isReporting={true}
        // showFilterModal={false}
        // filterModalType={"NA"}
        // setShowFilterModal={false}
        endDate={endDate}
        setEndDate={setEndDate}
              startDate={startDate}
              setStartDate={setStartDate}
              availableDates={availableDates}
              setCustomDatesToDisplay={setCustomDatesToDisplay}
      
              // Filter modal props (hooked up to real state)
              showFilterModal={showFilterModal}
              filterModalType={filterModalType}
              setShowFilterModal={setShowFilterModal}
        handleFilterItemSelect={() => { }}
        handleFilterMenuSelect={() => { }}
        isFilterActive={isFilterActive}
        showNav={false}
        showCancelButton
        handleCancelClick={handleCancelClick}
      />
      <div style={{ padding: "10px 10px 10px 5px" }}>
        <Typography variant="caption">
          Note: By default all dashboards are enabled for report generation
        </Typography>
      </div>
      {/* <div style={{ fontSize: "15px", marginLeft: '10px', marginBottom: '10px' }}>
        <label>
          <input
            style={{}}
            type="checkbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
          />
          &nbsp;
          {"Show Change Data"}
        </label>
      </div> */}
      {/* <Box
  sx={{
 display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          px: 1.25,
          mb: 1.25,
  }}
>
        
        <label style={{ fontSize: 15 }}>
            <input
      type="checkbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
    />
            &nbsp; Show Change Data
          </label>
      
        

      </Box > */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          px: 1.25,
          mb: 1.25,
        }}
      >
        {/* Left: checkbox */}
        <label style={{ fontSize: 15 }}>
          <input
            type="checkbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
          />
          &nbsp; Show Change Data
        </label>

        {/* Right: Template controls */}
        {/* <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          {editingTemplate && (
            <>
              <Button
                variant="contained"
                onClick={handleUpdateTemplate}
                title={`Update ${editingTemplate.template_name}`}
              >
                Update
              </Button>
              <Chip
                label={`Editing: ${editingTemplate.template_name}`}
                onDelete={handleCancelEdit}
                variant="outlined"
              />
            </>
          )}
          <TemplateSelector
            selectedOptionShow={selectedOptionShow}
            activeSequence={activeSequence}
            onLoadTemplate={handleLoadTemplate}
            onOpenTemplateManager={() => setTemplateManagerOpen(true)}
            isReady={isReady()}
          />
          { <Button
            size="small"
            variant="outlined"
            onClick={openClearDialog}
          >
            Clear
          </Button> }
        </Box> */}

        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          {editingTemplate && (
            <>
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  setTemplateManagerMode('update');
                  setTemplateManagerOpen(true);
                }}
                disabled={!isQuickSaveEnabled || isBusy}
                startIcon={<SaveIcon />}
                // sx={{
                //   backgroundColor: isQuickSaveEnabled ? '#4caf50' : undefined,
                //   '&:hover': {
                //     backgroundColor: isQuickSaveEnabled ? '#45a049' : undefined,
                //   }
                // }}
              >
                Update
              </Button>
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  // if (window.confirm('Cancel editing? Any unsaved changes will be lost.')) {
                  //   setEditingTemplate(null);
                  //   setSelectedTemplateInfo(null);
                  //   setOriginalTemplateSequence(null);
                  //   resetToInitialTabs();
                  // }
                  setEditingTemplate(null);
                  setSelectedTemplateInfo(null);
                  setOriginalTemplateSequence(null);
                  resetToInitialTabs();
                }}
                disabled={isBusy}
              >
                Cancel
              </Button>
            </>
          )}

          {!editingTemplate && selectedTemplateInfo && (
            <Chip
              label={`Active: ${selectedTemplateInfo.name}`}
              color="primary"
              variant="outlined"
              onDelete={resetToInitialTabs}
              deleteIcon={
                <Tooltip title="Click to reset to default configuration" arrow>
                  <CloseIcon />
                </Tooltip>
              }
              sx={{
                maxWidth: 250,
                '& .MuiChip-label': {
                  display: 'block',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }
              }}
            />
          )}

          {/* Normal Save button when NOT in edit mode */}
          {!editingTemplate && (
            <>
              <Button
                variant="outlined"
                size="small"
                onClick={(e) => {
                  if (selectedTemplateInfo) {
                    setSaveMenuAnchor(e.currentTarget);
                  } else {
                    setTemplateManagerMode('save');
                    setTemplateManagerOpen(true);
                  }
                }}
                disabled={!isQuickSaveEnabled || isBusy}
                startIcon={<SaveIcon />}
                endIcon={selectedTemplateInfo ? <ArrowDropDownIcon /> : null}
                title={
                  isSystemTemplate
                    ? "Cannot save changes to default templates"
                    : !hasConfigurationChanged()
                      ? "No changes to save"
                      : selectedTemplateInfo
                        ? `Save options for "${selectedTemplateInfo.name}"`
                        : "Save current configuration as new template"
                }
                // sx={{
                //   backgroundColor: isQuickSaveEnabled ? '#4caf50' : undefined,
                //   '&:hover': {
                //     backgroundColor: isQuickSaveEnabled ? '#45a049' : undefined,
                //   }
                // }}
              >
                Save
              </Button>

              {selectedTemplateInfo && (
                <Menu
                  anchorEl={saveMenuAnchor}
                  open={Boolean(saveMenuAnchor)}
                  onClose={() => setSaveMenuAnchor(null)}
                  PaperProps={{
                    sx: {
                      maxWidth: 350,
                      minWidth: 200
                    }
                  }}
                >
                  <MenuItem onClick={() => {
                    setSaveMenuAnchor(null);
                    setTemplateManagerMode('update');
                    setTemplateManagerOpen(true);
                  }}>
                    <SaveIcon fontSize="small" sx={{ mr: 1, flexShrink: 0 }} />
                    <Box sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }}>
                      Update "{selectedTemplateInfo?.name}"
                    </Box>
                  </MenuItem>
                  <MenuItem onClick={() => {
                    setSaveMenuAnchor(null);
                    setTemplateManagerMode('save');
                    setTemplateManagerOpen(true);
                  }}>
                    <FileCopyIcon fontSize="small" sx={{ mr: 1, flexShrink: 0 }} />
                    <Box sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }}>
                      Save as New Template
                    </Box>
                  </MenuItem>
                </Menu>
              )}
            </>
          )}

          <TemplateSelector
            selectedOptionShow={selectedOptionShow}
            activeSequence={activeSequence}
            onLoadTemplate={handleLoadTemplate}
            onOpenTemplateManager={() => setTemplateManagerOpen(true)}
            isReady={isReady()}
            disabled={!!editingTemplate}
          />
        </Box>
      </Box>
      <div>
        {shouldShowLoader() && (
          <div
            style={{
              fontSize: "19px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px",
              color: "green",
            }}
          >
            <Spinner
              as="span"
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
            />
            Please Wait...
          </div>
        )}
        {/* {(isLoading || jobStatus === "running") || */}
        {showProgressUI  ? (
          <>
            {/* {percentCompleted > 0 && (
              <Typography variant="h6">{`Downloading ${percentCompleted}%`}</Typography>
            )} */}
              <Typography variant="h6">
                Generating report… {percentCompleted}%
              </Typography>
            <BorderLinearProgress
              variant="determinate"
              value={percentCompleted}
            />
              {/* {(jobStatus === "running" || jobStatus === "failed" || jobStatus === "success") && (
                <Typography variant="body2" sx={{ mt: 1 }}>
                  Status: {jobStatus?.toUpperCase()}
                </Typography>
              )}
              {!!jobMessages?.length && (
                <div style={{ marginTop: 8, maxHeight: 120, overflow: "auto", background: "#fafafa", padding: 8, borderRadius: 6 }}>
                  {jobMessages.slice(-6).map((m, i) => (
                    <div key={i} style={{ fontSize: 12 }}>
                      <b>{m.level?.toUpperCase?.() || "INFO"}</b> — {m.msg}
                    </div>
                  ))}
                </div>
              )}
              {jobStatus === "success" && jobId && (
                <Button
                  size="small"
                  variant="outlined"
                  sx={{ mt: 1 }}
                  onClick={() => downloadJob(jobId)}
                >
                  Download again
                </Button>
              )} */}

            {Array.from({ length: 5 }).map((_, id) => (
              <Skeleton
                key={id}
                sx={{ fontSize: "30px", marginVertical: "8px" }}
              />
            ))}
          </>
        ) : (
          <>
            {activeSequence.length > 0 && (
              // <div className={classes.columns_container}>
              //   {activeSequence.map(({ id, label, config }) => (
              //     <div key={id} className={classes.each_column}>
              //       <Typography
              //         variant="body2"
              //         style={{ fontWeight: "bold", fontSize: "12px" }}
              //       >
              //         {label}
              //       </Typography>

              //       <DragDropContext onDragEnd={handleDragEnd}>
              //         <Droppable droppableId={`droppable-list-${id}`}>
              //           {(provided) => (
              //             <div
              //               ref={provided.innerRef}
              //               {...provided.droppableProps}
              //               className={classes.each_subrow_container}
              //             >
              //               {config.map((item, index) => (
              //                 <Draggable
              //                   key={item.id}
              //                   draggableId={String(item.id)}
              //                   index={index}
              //                 >
              //                   {(provided) => (
              //                     <div
              //                       ref={provided.innerRef}
              //                       {...provided.draggableProps}
              //                       {...provided.dragHandleProps}
              //                       style={{
              //                         opacity: item.is_active ? 1 : 0.5,
              //                         background: item.is_active
              //                           ? "#E3F2FD"
              //                           : "#F5F5F5",
              //                         borderLeft: item.is_active
              //                           ? "4px solid #007BFF"
              //                           : "4px solid #B0BEC5",
              //                         ...provided.draggableProps.style, // Ensures smooth dragging
              //                       }}
              //                       className={classes.each_subrow}
              //                       onClick={() =>
              //                         handleEnableDisable(id, item.id)
              //                       }
              //                     >
              //                       <ListItemText
              //                         primary={item.name}
              //                         primaryTypographyProps={{
              //                           variant: "caption",
              //                         }}
              //                       />
              //                       {item.generate_summary !== undefined && (
              //                         <div onClick={(e) => e.stopPropagation()}>
              //                           <Typography
              //                             variant="caption"
              //                             style={{
              //                               fontSize: "10px",
              //                               color: "grey",
              //                             }}
              //                           >
              //                             Summary:
              //                           </Typography>
              //                           <Switch
              //                             size="small"
              //                             sx={{ transform: "scale(0.8)" }}
              //                             checked={item.generate_summary}
              //                             onChange={(e) => {
              //                               e.stopPropagation();
              //                               handleSwitchChange(id, item.id);
              //                             }}
              //                           />
              //                         </div>
              //                       )}
              //                       {item.show_change !== undefined && (
              //                         <div onClick={(e) => e.stopPropagation()}>
              //                           <Typography
              //                             variant="caption"
              //                             style={{
              //                               fontSize: "10px",
              //                               color: "grey",
              //                             }}
              //                           >
              //                             Show Change:
              //                           </Typography>
              //                           <Switch
              //                             size="small"
              //                             sx={{
              //                               transform: "scale(0.8)",
              //                             }}
              //                             checked={item.show_change}
              //                             onChange={(e) => {
              //                               e.stopPropagation();
              //                               handleSwitchChange(
              //                                 id,
              //                                 item.id,
              //                                 "change"
              //                               );
              //                             }}
              //                           />
              //                         </div>
              //                       )}
              //                     </div>
              //                   )}
              //                 </Draggable>
              //               ))}
              //               {provided.placeholder}
              //             </div>
              //           )}
              //         </Droppable>
              //       </DragDropContext>
              //     </div>
              //   ))}
              // </div>
                <div className={classes.columns_container}>
                  {activeSequence.map(({ id, label, config }) => {
                    const fullyActive = isSectionFullyActive(id);
                    const partiallyActive = isSectionPartiallyActive(id);

                    return (
                      <div key={id} className={classes.each_column}>
                        {/* Section Header with Checkbox */}
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          marginBottom: '8px',
                          padding: '4px 0px'
                        }}>
                          <input
                            type="checkbox"
                            checked={fullyActive}
                            ref={checkbox => {
                              if (checkbox) {
                                checkbox.indeterminate = partiallyActive && !fullyActive;
                                // Apply custom styling based on state
                                if (fullyActive) {
                                  checkbox.style.accentColor = 'rgb(0, 123, 255)'; // Blue when fully selected
                                } else if (partiallyActive && !fullyActive) {
                                  checkbox.style.accentColor = '#888888'; // Grey when partially selected
                                } else {
                                  checkbox.style.accentColor = ''; // Default/white when unselected
                                }
                              }
                            }}
                            onChange={() => handleSectionToggle(id)}
                            style={{
                              marginRight: '8px',
                              cursor: 'pointer',
                              transform: 'scale(1.1)'
                            }}
                            title={
                              fullyActive ? `Deselect all ${label} items` :
                                partiallyActive ? `Select all ${label} items` :
                                  `Select all ${label} items`
                            }
                          />
                          <Typography
                            variant="body2"
                            style={{
                              fontWeight: "bold",
                              fontSize: "12px",
                              cursor: 'pointer',
                              flex: 1
                            }}
                            onClick={() => handleSectionToggle(id)}
                          >
                            {label}
                          </Typography>

                          {/* Optional: Show count of active items */}
                          {/* <Typography
                            variant="caption"
                            style={{
                              fontSize: '10px',
                              color: '#888',
                              marginLeft: '4px'
                            }}
                          >
                            {config.filter(item => item.is_active).length}/{config.length}
                          </Typography> */}
                        </div>

                        {/* Existing drag/drop content */}
                        <DragDropContext onDragEnd={handleDragEnd}>
                          <Droppable droppableId={`droppable-list-${id}`}>
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                className={classes.each_subrow_container}
                              >
                                {config.map((item, index) => (
                                  <Draggable
                                    key={item.id}
                                    draggableId={String(item.id)}
                                    index={index}
                                  >
                                    {(provided) => (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={{
                                          opacity: item.is_active ? 1 : 0.5,
                                          background: item.is_active
                                            ? "#E3F2FD"
                                            : "#F5F5F5",
                                          borderLeft: item.is_active
                                            ? "4px solid #007BFF"
                                            : "4px solid #B0BEC5",
                                          ...provided.draggableProps.style,
                                        }}
                                        className={classes.each_subrow}
                                        onClick={() =>
                                          handleEnableDisable(id, item.id)
                                        }
                                      >
                                        <ListItemText
                                          primary={item.name}
                                          primaryTypographyProps={{
                                            variant: "caption",
                                          }}
                                        />
                                        {item.generate_summary !== undefined && (
                                          <div onClick={(e) => e.stopPropagation()}>
                                            <Typography
                                              variant="caption"
                                              style={{
                                                fontSize: "10px",
                                                color: "grey",
                                              }}
                                            >
                                              Summary:
                                            </Typography>
                                            <Switch
                                              size="small"
                                              sx={{ transform: "scale(0.8)" }}
                                              checked={item.generate_summary}
                                              onChange={(e) => {
                                                e.stopPropagation();
                                                handleSwitchChange(id, item.id);
                                              }}
                                            />
                                          </div>
                                        )}
                                        {item.show_change !== undefined && (
                                          <div onClick={(e) => e.stopPropagation()}>
                                            <Typography
                                              variant="caption"
                                              style={{
                                                fontSize: "10px",
                                                color: "grey",
                                              }}
                                            >
                                              Show Change:
                                            </Typography>
                                            <Switch
                                              size="small"
                                              sx={{
                                                transform: "scale(0.8)",
                                              }}
                                              checked={item.show_change}
                                              onChange={(e) => {
                                                e.stopPropagation();
                                                handleSwitchChange(
                                                  id,
                                                  item.id,
                                                  "change"
                                                );
                                              }}
                                            />
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </Draggable>
                                ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                        </DragDropContext>
                      </div>
                    );
                  })}
                </div>
            )}
              <Dialog open={clearDialogOpen} onClose={closeClearDialog} fullWidth>
                <DialogTitle>Clear Sections</DialogTitle>
                <DialogContent>
                  <FormGroup>
                    {activeSequence.map(({ id, label }) => (
                      <FormControlLabel
                        key={id}
                        control={
                          <Checkbox
                            checked={selectedSections.includes(id)}
                            onChange={() => toggleSection(id)}
                          />
                        }
                        label={label}
                      />
                    ))}
                  </FormGroup>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "space-between" }}>
                  <div>
                    <Button size="small" onClick={selectAll}>Select All</Button>
                    <Button size="small" onClick={selectNone}>None</Button>
                  </div>
                  <div>
                    <Button onClick={closeClearDialog}>Cancel</Button>
                    <Button
                      variant="contained"
                      disabled={selectedSections.length === 0}
                      onClick={applyClear}
                    >
                      Apply
                    </Button>
                  </div>
                </DialogActions>
              </Dialog>

              <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={() => setSnackbarOpen(false)}
                message={`Cleared ${selectedSections.length} section(s)`}
                action={
                  <Button color="secondary" size="small" onClick={handleUndo}>
                    UNDO
                  </Button>
                }
              />

          </>
        )}
      </div>
      <ToastContainer />
      {/* <ReportTemplateManager
        open={templateManagerOpen}
        onClose={() => setTemplateManagerOpen(false)}
        selectedOptionShow={selectedOptionShow}
        activeSequence={activeSequence}
        onLoadTemplate={handleLoadTemplate}
        user_id={user?.user_role?.user_id}
        onStartEdit={handleStartEdit}
      /> */}
      <ReportTemplateManager
        open={templateManagerOpen}
        onClose={() => {
          setTemplateManagerOpen(false);
          setTemplateManagerMode('list'); // Reset to list view
        }}
        selectedOptionShow={selectedOptionShow}
        activeSequence={activeSequence}
        onLoadTemplate={handleLoadTemplate}
        user_id={user?.user_role?.user_id}
        onStartEdit={handleStartEdit}
        initialView={templateManagerMode} // Pass the mode
        currentTemplateInfo={selectedTemplateInfo} // Pass current template for update mode
        isChecked={isChecked} // Pass show change data state
        onTemplateDeleted={handleTemplateDeleted} 
      />
    </div>
  );
}
